import React, { useState, useContext, useEffect } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { CreateRequisitionModal } from './Modal_CreateRequisition';
import { ViewReq_ApplicationsRecievedList } from '../../../zInternal_Features/merchant/components/ViewRequisition_ApplicationsRecieved_List'
import { DeleteRequisitionModal } from '../../../zInternal_Features/merchant/components/Modal_DeleteRequisition';
import { JobDescriptionModal } from '../../../zInternal_Features/merchant/components/Modal_JobDescription';

import '../../../css/layout.css';


export function  Tab_Overview_Jobs () {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [createRequisitionModal, setCeateRequisitionModal] = useState(false);
    let [viewRequistion_overviewModal, setViewRequistion_overviewModal]= useState(false);
    let [deleteRequisitionModal, setDeleteRequisitionModal] = useState(false);

    let [viewRequisitionList, setViewRequisitionList] = useState([]);

    let [requisitionID, setRequisitionID] = useState(false);
    let [requisitionName, setRequisitionName] = useState(false);
    let [requisitionResponsibilites, setRequisitionResponsibilites] = useState(false);
    let [requisitionQualifications, setRequisitionQualifications] = useState(false);
    let [requisitionDeadline, setRequisitionDeadline] = useState(false);

    let [showJobDescriptionModal, setShowJobDescriptionModal] = useState(false);


    useEffect(() => {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_requisitions_overview",
                user: acctID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewRequisitionList((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        requisitionID: cols[0],
                        companyRole: cols[1],
                        requisitionName: cols[2],
                        requisitionResponsibilites: cols[3],
                        requisitionQualifications: cols[4],
                        requisitionDeadline: cols[5],
                        dateCreated: cols[6],
                        numApplicationsRecieved: cols[7],
    
                    })
                });
            } 
        })

    }, [])            
        

    function viewJobDescriptionModalHandler(event)
    {
        setRequisitionID(event[1]);
        setRequisitionName(event[2]);
        setRequisitionResponsibilites(event[3]);
        setRequisitionQualifications(event[4]);
        setRequisitionDeadline(event[5]);

        setShowJobDescriptionModal(event[0]);
    }

    function applicationListHandler(event) {
        
        setRequisitionID(event[1]);
        setViewRequistion_overviewModal(true);

    }


    return (
        <React.Fragment>

            <IonItem>
                <IonGrid>
                    <IonRow style={{color: 'black'}}>
                        <IonCol>
                            <h3> Posted Jobs </h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            {(authenticatedMerchent_context.selectedTutorial?.tutorial_id == '9' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) 
                            ? <IonButton  className='flash-tutorial' onClick={() => setCeateRequisitionModal(true)}>Create Post</IonButton>
                            : <IonButton  onClick={() => setCeateRequisitionModal(true)}>Create Post</IonButton>}
                        </IonCol>
                        <IonCol size='6'>
                            {(authenticatedMerchent_context.selectedTutorial?.tutorial_id == '10' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) 
                            ? <IonButton  className='flash-tutorial' onClick={() => setDeleteRequisitionModal(true)}>Delete Post</IonButton>
                            : <IonButton  onClick={() => setDeleteRequisitionModal(true)}>Delete Post</IonButton>}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonItem>

            <IonContent className='grid_content'>

            <div style={{ display: 'inline-block', marginTop: '120px' }}>
                        <div style={{display: 'inline-block'}}>
                            <IonGrid >
                                <IonRow >
                                        <IonCol size='1' >ID</IonCol>
                                        <IonCol size='4' >Name</IonCol>
                                        <IonCol size='2' >Applicants</IonCol>
                                        <IonCol size='5'>Action</IonCol>
                                </IonRow>
                                {viewRequisitionList.map((detailData) =>   {
                                    return (
                                        <IonRow className='gridResultBody'>
                                            <IonCol size='1' >{detailData.requisitionID}</IonCol>
                                            <IonCol size='4' >{detailData.requisitionName}</IonCol>
                                            <IonCol size='2' >{detailData.numApplicationsRecieved}</IonCol>
                                            <IonCol size='5' >
                                                {/*<IonButton  > Image </IonButton>*/}
                                                <IonButton  className='small_button' onClick={() => applicationListHandler([true, detailData.requisitionID])}> Submissions </IonButton>
                                                <IonButton  className='small_button' onClick={() => viewJobDescriptionModalHandler([true, detailData.requisitionID, detailData.requisitionName, detailData.requisitionResponsibilites, detailData.requisitionQualifications, detailData.requisitionDeadline])}> Job Post </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                        </div>

               {createRequisitionModal  == true && <CreateRequisitionModal openModal= { createRequisitionModal } closeModal={() => setCeateRequisitionModal(false)}></CreateRequisitionModal>}
                
                {showJobDescriptionModal == true && 
                <JobDescriptionModal openModal={ showJobDescriptionModal } closeModal={() => setShowJobDescriptionModal(false)} data={{
                    requisitionID: requisitionID, 
                    requisitionName: requisitionName,
                    requisitionResponsibilites: requisitionResponsibilites,
                    requisitionQualifications: requisitionQualifications,
                    requisitionDeadline: requisitionDeadline,
                                        }}></JobDescriptionModal>}

              {viewRequistion_overviewModal == true &&  <ViewReq_ApplicationsRecievedList openModal= { viewRequistion_overviewModal } closeModal={() => setViewRequistion_overviewModal(false)}  data={{
                    requisitionID: requisitionID,
                    requisitionName: requisitionName,
                                        }}></ViewReq_ApplicationsRecievedList>}

               {deleteRequisitionModal == true && <DeleteRequisitionModal openModal= { deleteRequisitionModal } closeModal={() => setDeleteRequisitionModal(false)}> </DeleteRequisitionModal>}
            </div>

            </IonContent>

            </React.Fragment>

        )
}